export default "__VITE_ASSET__DkI5fn6l__"